import script from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=js"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=52df39f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52df39f3"]])

export default __exports__